import MentoringEmptyTeams from './MentoringEmptyTeams.vue';

export default MentoringEmptyTeams;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/emptyteams/index.ts